<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card class="mt-4">
          <v-card-title class="third white--text font-weight-bold">
            <span class="col-11">Informations de Assurance</span>
            <v-tooltip v-if="!hasValidInsurance" class="col-1" bottom>
              <template #activator="{ on, insuranceIcon }">
                <v-icon v-bind="insuranceIcon" class="disable no-pointer" v-on="on">mdi-download-circle-outline</v-icon>
              </template>
              <span>Le téléchargement du document est indisponible, car l'assurance a été importée depuis Kavalog.</span>
            </v-tooltip>
            <v-icon v-else class="col-1 white--text" @click="downloadInsurance(insurance)">mdi-download-circle-outline</v-icon>
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="4" class="px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Nom de l'assurance</v-list-item-subtitle>
                    <v-list-item-title v-if="insurance && insurance.type">{{ insurance.type }}</v-list-item-title>
                    <v-list-item-title v-else>--</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="4" class="px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Date de souscription</v-list-item-subtitle>
                    <v-list-item-title v-if="insurance && insurance.subscriptionDate">{{ insurance.subscriptionDate }}</v-list-item-title>
                    <v-list-item-title v-else>--</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="4" class="px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Numéro de dossier</v-list-item-subtitle>
                    <v-list-item-title v-if="insurance && insurance.bookingNumber">{{ insurance.bookingNumber }}</v-list-item-title>
                    <v-list-item-title v-else>--</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="4" class="px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Date de début</v-list-item-subtitle>
                    <v-list-item-title v-if="insurance && insurance.startDate">{{ insurance.startDate }}</v-list-item-title>
                    <v-list-item-title v-else>--</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="4" class="px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Date de fin</v-list-item-subtitle>
                    <v-list-item-title v-if="insurance && insurance.endDate">{{ insurance.endDate }}</v-list-item-title>
                    <v-list-item-title v-else>--</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';
import { getInsuranceFile } from '../../../helpers/request';
import { sendNotification, downloadBase64File } from '@/helpers/utils';

export default {
  props: {
    insurance: {
      type: Object,
      default: () => {}
    },
    customer: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    const hasValidInsurance = computed(() => !!props.insurance.insurance_declaration_paper);

    const downloadInsurance = async insurance => {
      if (!hasValidInsurance.value) return;

      if (!insurance.insurance_declaration_paper) {
        sendNotification('error', 'Le document n\'est pas disponible');
        return;
      }

      const modifiedUrl = insurance.insurance_declaration_paper.replace(/&amp;/g, '&');
      const file = await getInsuranceFile(modifiedUrl);

      if (!file.success) {
        sendNotification('error', 'Le document n\'est pas disponible');
        return;
      }

      const fileName = `${props.customer.fullname}_${props.insurance.bookingNumber}`;
      downloadBase64File(file, fileName);
    };
    return { downloadInsurance, hasValidInsurance };
  }

};
</script>
